import React from 'react';

import { DocumentSpecifiqueDto } from 'lib_api/lib/api/gen';

import useDocumentSpecifique from 'hooks/referentiels/DocumentSpecifique/useDocumentSpecifique';

import DocumentSpecifiqueCard from './DocumentSpeciiqueCard/DocumentSpecifiqueCard';

export interface DocumentSpecifiqueCardsProps {
  isAdmin?: boolean;
  lastModificationDate?: number | undefined;
  onDelete?: (document: DocumentSpecifiqueDto) => void;
}

function DocumentSpecifiqueCards({
  isAdmin,
  lastModificationDate,
  onDelete,
}: DocumentSpecifiqueCardsProps): React.ReactElement {
  const documentsSpecifiques = useDocumentSpecifique(lastModificationDate);

  return (
    <>
      {!isAdmin && <h1>Documents spécifiques</h1>}
      {documentsSpecifiques.map(document => (
        <DocumentSpecifiqueCard
          isAdmin={isAdmin}
          document={document}
          key={document.id}
          onDelete={onDelete}
        />
      ))}
    </>
  );
}

export default DocumentSpecifiqueCards;
